import styled from "styled-components";
import { Button } from "../../../components";

export const SubmitButton = styled(Button.Primary)`
  width: 100%;
  margin-top: 10px;
`;
